import React from 'react';

import { Container, Title, TitleRow } from './scan-and-pay-layout.styled';
import { IScanAndPayLayout } from './types';

export const ScanAndPayLayout = ({
  title,
  headerElement,
  children,
  ...props
}: IScanAndPayLayout) => (
  <Container {...props}>
    <TitleRow>
      <Title>{title}</Title>
      {headerElement}
    </TitleRow>
    {children}
  </Container>
);
